import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-sidebar/graphQL/... Remove this comment to see the full error message
import { client } from 'customer-data-sidebar/graphQL/client';
import { ApolloProvider } from '@apollo/client';
import { PropertiesProvider } from 'customer-data-properties/context';
import ProfilePermissionsContainer from '../crm_ui/permissions/ProfilePermissionsContainer';
import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
import { CRM_UI } from 'customer-data-objects/property/PropertySourceTypes';
import getIn from 'transmute/getIn';
import { PropertySourceContext } from '../crm_ui/profile/PropertySourceContext';
import { SubjectContext, SubjectData } from '../crm_ui/profile/SubjectContext';
import { useUserInfo } from '../hooks/useUserInfo';
import { useSidebarCollapseQuickFetch } from '../hooks/useSidebarCollapseQuickFetch';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'crm_data/objects/ObjectsAction... Remove this comment to see the full error message
import ObjectsActions from 'crm_data/objects/ObjectsActions';
import PageRefreshUsageLogger from '../crm_ui/components/shared/PageRefreshUsageLogger';
import { isValidEmail } from 'customer-data-properties/validation/PropertyValidations';
import memoize from 'transmute/memoize';
import ErrorPage from '../crm_ui/error/ErrorPage';
import { RESET_TIMELINE_STATE } from 'crm-events-data/internal/redux/createStore';
import { useTimelineDispatch } from 'crm-events-data/internal/redux/reduxHooks';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { CrmLinksDataProvider } from 'crm-links/common/context/CrmLinksDataProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isValidSubjectId = memoize(subjectId => {
  return /^(\d+)$/.test(subjectId);
});
export default function RecordDataProvider({
  objectType,
  subjectId,
  children
}) {
  const history = useHistory();
  const [propertySourceInfo, _setPropertySourceInfo] = useState(null);
  const setPropertySourceInfo = useCallback(user => _setPropertySourceInfo({
    propertySourceId: getIn(['user', 'email'], user),
    propertySource: CRM_UI
  }), []);
  const dataFetchingClient = useMemo(() => {
    return new DataFetchingClient();
  }, []);
  useUserInfo(setPropertySourceInfo);
  useSidebarCollapseQuickFetch();
  const timelineDispatch = useTimelineDispatch();
  useEffect(() => {
    ObjectsActions.refresh(objectType, subjectId);
    timelineDispatch({
      type: RESET_TIMELINE_STATE
    });
  }, [objectType, subjectId, timelineDispatch]);
  const subjectData = useMemo(() => {
    return SubjectData({
      objectType,
      subjectId: String(subjectId)
    });
  }, [objectType, subjectId]);
  if (objectType === CONTACT && isValidEmail(decodeURIComponent(subjectId))) {
    history.replace(`/contact/email/${decodeURIComponent(subjectId)}`);
    return null;
  }
  if (!isValidSubjectId(subjectId)) {
    return /*#__PURE__*/_jsx(ErrorPage, {
      errorCode: "404",
      "data-test-id": "record-data-provider-error"
    });
  }
  return /*#__PURE__*/_jsx(SubjectContext.Provider, {
    value: subjectData,
    children: /*#__PURE__*/_jsx(PropertySourceContext.Provider, {
      value: propertySourceInfo,
      children: /*#__PURE__*/_jsx(ApolloProvider, {
        client: client,
        children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
          client: dataFetchingClient,
          children: /*#__PURE__*/_jsx(CrmLinksDataProvider, {
            children: /*#__PURE__*/_jsx(PropertiesProvider, {
              children: /*#__PURE__*/_jsxs(ProfilePermissionsContainer, {
                objectType: objectType,
                subjectId: subjectId,
                children: [children, /*#__PURE__*/_jsx(PageRefreshUsageLogger, {
                  objectType: objectType
                })]
              })
            })
          })
        })
      })
    })
  });
}